import domain from '@framework/config/domain';
import env from '@framework/env/env';

export const config = {
  name: 'Evercall',
  code: 'evercall' as const,
  abbr: 'EVC',
  supportEmail: env('CREDENTIALS__EVERCALL__SUPPORT__EMAIL'),
  salesEmail: env('CREDENTIALS__EVERCALL__SUPPORT__SALES_EMAIL'),
  hostname: `${ domain.evercallDomain }`,
  supportPhoneNumber: env('CREDENTIALS__EVERCALL__SUPPORT__PHONE'),
  ga: {
    trackingId: env('GA__TRACKING_ID_EVERCALL'),
  },
  gtm: {
    trackingId: env('FRONTEND___GOOGLE_TAG_MANAGER__TENANT_EVERCALL__GTM_ID'),
  },
};

export default config;
